import React from "react";
import styled from "@emotion/styled";

const Row = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 36px 10px 33px;
  cursor: pointer;
  transition: background 0.15s;
  border-left: 3px solid transparent;

  &:hover {
    background: ${
      theme.type === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.02)"
    };
    border-left-color: ${theme.primary};
  }

  &:active {
    background: ${
      theme.type === "dark" ? "rgba(255,255,255,0.07)" : "rgba(0,0,0,0.04)"
    };
  }

  & + & {
    border-top: 1px solid ${
      theme.type === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"
    };
  }
`
);

const IconWrap = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 6px;
  margin-top: 1px;
  background: ${
    theme.type === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)"
  };
  color: ${theme.text.disabled};
`
);

const Body = styled.div`
  min-width: 0;
  flex: 1;
`;

const Title = styled.div(
  ({ theme }) => `
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: ${theme.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
);

const Meta = styled.div(
  ({ theme }) => `
  font-size: 11px;
  line-height: 1.4;
  margin-top: 2px;
  color: ${theme.text.disabled};
`
);

export default function QuickAccessRow({ icon, title, meta, onClick }) {
  return (
    <Row onClick={onClick}>
      <IconWrap>{icon}</IconWrap>
      <Body>
        <Title>{title}</Title>
        {meta && <Meta>{meta}</Meta>}
      </Body>
    </Row>
  );
}
